import { Component, OnInit } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Notificationpreference } from './model/notificationpreference';
import { Notificationpreferenceset } from './model/notificationpreferenceset';
import { OrgnotificationsettingService } from './service/orgnotificationsetting.service';
import {
  trigger,
  state,
  style,
  animate,
  transition,
} from "@angular/animations";
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-orgnotificationsetting',
  templateUrl: './orgnotificationsetting.component.html',
  styleUrls: ['./orgnotificationsetting.component.css'],
  animations: [
    trigger("inbgOutAnimation", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("0.2s ease-out", style({ opacity: 1 })),
      ]),
      transition(":leave", [
        style({ opacity: 1 }),
        animate("0.2s ease-in", style({ opacity: 0 })),
      ]),
    ]),
    trigger("taskdoneAnimation", []),
  ],
})
export class OrgnotificationsettingComponent implements OnInit {
  notificationList: Notificationpreference[];
  noNotificationsMsg: string;
  notificationpreferenceset: Notificationpreferenceset;
  showSpinner: boolean;
  showDeal: boolean = false;
  overduecheck: boolean;
  memberfarbehindcheck: boolean;
  newprojectcheck: boolean;
  newdealcheck: boolean;
  projectdisabedcheck: boolean;
  projectreenabledcheck: boolean;
  projectdeletedcheck: boolean;
  showcustomeruseroptions: boolean;
  organizationId: string;
  constructor(private nssrv: OrgnotificationsettingService) { }

  ngOnInit(): void {
    this.organizationId = SessionHelper.getChoosenOrg();
    this.showDeal = SessionHelper.getHubspot() ? true : false;
    this.showSpinner = true;
    this.notificationList = [];
    this.notificationpreferenceset = new Notificationpreferenceset;
    this.noNotificationsMsg = "No notification preferences for this organization."
    this.nssrv.getNotificationPreferences(SessionHelper.getUserSub()).pipe(untilDestroyed(this)).subscribe(onpl => {
      //console.log('notification preference list ',onpl);
      this.notificationList = onpl.filter(x => x.personId == SessionHelper.getUserSub());
      this.notificationpreferenceset.memberfarbehind = this.notificationList.find(x => x.preference == "memberfarbehind") ? this.notificationList.find(x => x.preference == "memberfarbehind").preferencevalue : false;
      this.notificationpreferenceset.newproject = this.notificationList.find(x => x.preference == "newproject") ? this.notificationList.find(x => x.preference == "newproject").preferencevalue : false;
      this.notificationpreferenceset.newdeal = this.notificationList.find(x => x.preference == "newdeal") ? this.notificationList.find(x => x.preference == "newdeal").preferencevalue : false;
      this.notificationpreferenceset.projectdeleted = this.notificationList.find(x => x.preference == "projectdeleted") ? this.notificationList.find(x => x.preference == "projectdeleted").preferencevalue : false;
      this.notificationpreferenceset.projectdisabed = this.notificationList.find(x => x.preference == "projectdisabed") ? this.notificationList.find(x => x.preference == "projectdisabed").preferencevalue : false;
      this.notificationpreferenceset.projectreenabled = this.notificationList.find(x => x.preference == "projectreenabled") ? this.notificationList.find(x => x.preference == "projectreenabled").preferencevalue : false;
      this.notificationpreferenceset.projectturnsoverdue = this.notificationList.find(x => x.preference == "projectturnsoverdue") ? this.notificationList.find(x => x.preference == "projectturnsoverdue").preferencevalue : false;
      this.showSpinner = false;
    });
  }
  setNotificationPreference(event, notfstr: string) {
    var notf: Notificationpreference;
    if (this.notificationList.find(x => x.preference = notfstr)) {
      notf = this.notificationList.find(x => x.preference = notfstr);
    } else {
      notf = new Notificationpreference;
      notf.lastupdate = new Date();
      notf.organizationId = SessionHelper.getChoosenOrg();
      notf.personId = SessionHelper.getUserSub();
      notf.preference = notfstr;
    }
    notf.preferencevalue = event.srcElement.checked;
    //console.log('preference to be saved',notf);
    this.nssrv.setNotificationPreferences(notf).pipe(untilDestroyed(this)).subscribe(result => {
      //console.log('Response from service',result);
    });


  }
  getNotificationPreference(not: string) {
    if (this.notificationList.find(x => x.preference = not)) {
      return this.notificationList.find(x => x.preference = not).preferencevalue;
    } else {
      return false;
    }
  }

  checkAll() {
    this.overduecheck = true;
    this.memberfarbehindcheck = true;
    this.newprojectcheck = true;
    this.newdealcheck = true;
    this.projectdisabedcheck = true;
    this.projectreenabledcheck = true;
    this.projectdeletedcheck = true;
  }


  checkNone() {
    this.overduecheck = false;
    this.memberfarbehindcheck = false;
    this.newprojectcheck = false;
    this.newdealcheck = false;
    this.projectdisabedcheck = false;
    this.projectreenabledcheck = false;
    this.projectdeletedcheck = false;
  }

  toggleCustomeruser() {
    this.showcustomeruseroptions = true;
  }

  toggleOrg() {
    this.showcustomeruseroptions = false;
  }
}
